const aws = require('aws-sdk')
import axios from "axios";

aws.config.update({
  accessKeyId: "AKIAIXRTDZARPO5WAUKA",
  secretAccessKey: "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"
})

var s3 = new AWS.S3();

export const singleUpload = (file, baseFolder, targetFolder) => {
  return new Promise((resolve, reject) => {
    if (targetFolder) {
      targetFolder = "images"
    }
    //configuring parameters
    const fullFilePathAws = baseFolder + '/' + Date.now() + '-' + file.name.replace(/\s/g, '-')
    var params = {
      Bucket: 'swg-images',
      Key : fullFilePathAws
    };
    s3.headObject(params, function (err, metadata) {
      if (err && err.code === 'NotFound') {
        // Handle no object on cloud here
        if (!fullFilePathAws) {
          fullFilePathAws = targetFolder + "/" + Date.now() + "_" + path.basename(fullFilePathLocal)
        }
        params.Body = file;
        console.log("Before upload");

        s3.upload(params, function (err, data) {
          //handle error
          if (err) {
            console.log("Error ", err);
            console.log("Data? ", data);
            reject(err)
          } else {
            //success
            if (data) {
              console.log("Uploaded in:", data.Location);
              resolve(data.Location)
            } else {
              reject()
            }
          }
        });
      } else {
        resolve("https://swg-images.s3.amazonaws.com/" + fullFilePathAws)
      }
    });
  })
}

export const deleteObjectByKey = key => {
  const params = {
    Bucket: "swg-images",
    Key: key,
  }
  const data = s3.deleteObject(params).promise()

  return data
}
